import React, { createContext, useContext, useState, ReactNode, useEffect } from 'react';
import { PlanosService } from '../../../../planos/estabelecimento/Service';
import { baseURL } from '../../../../../AxiosConfig';
import { UserService } from '../../../../configuracoes/usuario/Service';
import { ServicosService } from '../../../../servicos/Service';

const userService = new UserService();
const servicosService = new ServicosService()

interface ClientData {
    value: any,
    label: any
}

const planosService = new PlanosService();

interface PlanoContextType {
    plano: any;
    setPlano: React.Dispatch<React.SetStateAction<any>>;
    optionsPlano: any[];
    servicesOptions: any[];
    clients: ClientData[];
    clientId: string;
    setClientId: React.Dispatch<React.SetStateAction<string>>;
    loading: boolean
    startAt: Date
    setStartAt: React.Dispatch<React.SetStateAction<Date>>;
}

const PlanoContext = createContext<PlanoContextType | undefined>(undefined);

export const PlanoFormProvider = ({ children }: { children: ReactNode }) => {
    const [plano, setPlano] = useState<any>();
    const [loading, setLoading] = useState(true);
    const [clientId, setClientId] = useState<string>('');
    const [startAt, setStartAt] = useState<Date>(new Date());
    const [optionsPlano, setOptionPlano] = useState<any[]>([]);
    const [clients, setClients] = useState<ClientData[] | []>([]);
    const [servicesOptions, setServicesOptions] = useState<any[]>([]);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await planosService.findAll();

                setOptionPlano(data.filter((plano: any) => plano.status === 1));
            } catch (e) {

            }

            try {
                const { data } = await userService.getClients();
                const clientsOptions = data.map((client: any) => ({
                    label: (
                        <div className="flex items-center gap-2">
                            <img src={`${baseURL}/users/profileImage/${client?.uid}`} alt="User Avatar"
                                 className="w-6 h-6 rounded-full object-cover" />
                            <span>{client.displayName}</span>
                        </div>
                    ),
                    value: client.uid,
                }));
                setClients(clientsOptions);
            } catch (error) {
                console.error('Erro ao buscar clientes:', error);
            }

            try {
                const { data } = await servicosService.findAll();

                setServicesOptions(data?.map(({ _id, name }: any) => ({ label: name, value: _id })));
            } catch (e) {

            }

            setLoading(false);
        })();
    }, []);

    return (
        <PlanoContext.Provider value={{
            plano,
            setPlano,
            optionsPlano,
            clients,
            clientId,
            setClientId,
            loading,
            servicesOptions,
            startAt,
            setStartAt,
        }}>
            {children}
        </PlanoContext.Provider>
    );
};

export const usePlanoForm = () => {
    const context = useContext(PlanoContext);
    if (!context) {
        throw new Error('usePlanoForm deve ser usado dentro de PlanoFormProvider');
    }
    return context;
};
